export default __webpack_public_path__ + "static/media/2023-01-19-twitter-developer-terms.18244023.md";